import axios from 'axios';
import * as qs from 'qs';
import { ICrudGetAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, IStaySurvey } from 'app/shared/model/stay_survey';
import { ICrudGetListAction } from 'app/shared/model/list';
import { flattenKey } from 'app/shared/util/object-utils';
import { cleanEntity } from 'app/shared/util/entity-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_STAYSURVEY_LIST: 'staySurvey/FETCH_STAYSURVEY_LIST', // 列表
  CREATE_STAYSURVEY: 'staySurvey/CREATE_STAYSURVEY', // 创建
  FETCH_STAYSURVEY: 'staySurvey/FETCH_STAYSURVEY', // 详情
  UPDATE_STAYSURVEY: 'staySurvey/UPDATE_STAYSURVEY', // 更新
  DELETE_STAYSURVEY: 'staySurvey/DELETE_STAYSURVEY', // 删除
  RESET: 'staySurvey/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IStaySurvey>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  searchForm: {}
};

export type staySurveyState = Readonly<typeof initialState>;

// Reducer
export default (state: staySurveyState = initialState, action): staySurveyState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_STAYSURVEY):
    case REQUEST(ACTION_TYPES.CREATE_STAYSURVEY):
    case REQUEST(ACTION_TYPES.UPDATE_STAYSURVEY):
    case REQUEST(ACTION_TYPES.DELETE_STAYSURVEY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case REQUEST(ACTION_TYPES.FETCH_STAYSURVEY_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case FAILURE(ACTION_TYPES.UPDATE_STAYSURVEY):
    case FAILURE(ACTION_TYPES.CREATE_STAYSURVEY):
    case FAILURE(ACTION_TYPES.FETCH_STAYSURVEY):
    case FAILURE(ACTION_TYPES.FETCH_STAYSURVEY_LIST):
    case FAILURE(ACTION_TYPES.DELETE_STAYSURVEY):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.DELETE_STAYSURVEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case SUCCESS(ACTION_TYPES.FETCH_STAYSURVEY):
      const { data } = action.payload;
      let { reason, source, sourceWay } = data;

      const otherChange = (value, name) => {
        const arr = value.split(':');
        data[`${name}_other`] = arr[1];
        return arr[0];
      };

      reason = reason && reason.indexOf('其他') > -1 ? otherChange(reason, 'reason') : reason;
      sourceWay = sourceWay && sourceWay.indexOf('其他') > -1 ? otherChange(sourceWay, 'sourceWay') : sourceWay;

      if (source && source.indexOf('其他') > -1) {
        const arr = source.split(',');
        const num = arr.findIndex(item => item.indexOf('其他') > -1);
        arr[num] = otherChange(arr[num], 'source');
        source = arr;
      }

      return {
        ...state,
        loading: false,
        entity: { ...data, reason, sourceWay, source }
      };
    case SUCCESS(ACTION_TYPES.UPDATE_STAYSURVEY):
    case SUCCESS(ACTION_TYPES.CREATE_STAYSURVEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_STAYSURVEY_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data || [],
        totalItems: parseInt(action.payload.headers['x-total-count'], 10)
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/occupancy'; // 入住记录
const initpage = 0; // 初始页码
const initsize = 20; // 条数
// Actions
// 入住记录，列表
export const getEntities: ICrudGetListAction<IStaySurvey> = (page, size, sort, searchForm) => {
  const requestUrl = `${apiUrl}/page?page=${page}&size=${size}`;
  initialState.searchForm = { ...searchForm };
  return {
    type: ACTION_TYPES.FETCH_STAYSURVEY_LIST,
    payload: axios.get<IStaySurvey>(
      `${requestUrl}${sort ? `&sort=${sort}&cacheBuster=${new Date().getTime()}` : `?cacheBuster=${new Date().getTime()}`}`,
      {
        params: flattenKey(searchForm),
        paramsSerializer: params => qs.stringify(params)
      }
    ),
    meta: { transformUserName: true }
  };
};
// 新增入住记录
export const createEntity = entity => async (dispatch, getState) => {
  const {
    expenseGrade: { searchData }
  } = getState();
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_STAYSURVEY,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities(initpage, initsize, '', initialState.searchForm));
  return result;
};
// 获取入住记录数据
export const getEntity: ICrudGetAction<IStaySurvey> = id => {
  const requestUrl = `${apiUrl}/detail/${id}`;
  return {
    type: ACTION_TYPES.FETCH_STAYSURVEY,
    payload: axios.get<IStaySurvey>(requestUrl)
  };
};
export const updateEntity: ICrudPutAction<IStaySurvey> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_STAYSURVEY,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  // dispatch(getEntities());
  return result;
};
// 删除
export const deleteEntity: ICrudDeleteAction<IStaySurvey> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_STAYSURVEY,
    payload: axios.delete(requestUrl)
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
